/** Study mode cursor persistence helpers.
 *
 * These functions manage a localStorage-backed cursor that tracks
 * the user's position within a study session (page, index, seed).
 */

export interface StudyCursor {
  page: number;
  idx: number;
  globalIdx: number;
  total: number;
  seed: string;
  savedAt: number;
}

export function cursorKey(certCode: string, topic: string | undefined, difficulty: string | undefined): string {
  return `cloudmaster_cursor_${certCode}_${topic ?? 'all'}_${difficulty ?? 'all'}`;
}

export function generateSeed(): string {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function loadCursor(certCode: string, topic: string | undefined, difficulty: string | undefined): StudyCursor | null {
  try {
    const raw = localStorage.getItem(cursorKey(certCode, topic, difficulty));
    return raw ? (JSON.parse(raw) as StudyCursor) : null;
  } catch {
    return null;
  }
}

export function saveCursor(certCode: string, topic: string | undefined, difficulty: string | undefined, cursor: StudyCursor): void {
  localStorage.setItem(cursorKey(certCode, topic, difficulty), JSON.stringify(cursor));
}

export function clearCursor(certCode: string, topic: string | undefined, difficulty: string | undefined): void {
  localStorage.removeItem(cursorKey(certCode, topic, difficulty));
}
